define('fonts/fonts',{
  system: {
    "Arial": "",
    "Comic Sans MS": "",
    "Courier New": "",
    "Georgia": "",
    "Tahoma": "",
    "Times New Roman": "",
    "Trebuchet MS": "",
    "Verdana": ""
  },
  google: {
   "Abril Fatface": "Abril+Fatface",
   "Amatic SC": "Amatic+SC:400,700",
   "Arvo": "Arvo:400,700",
   "Dancing Script": "Dancing+Script:400,700",
   "Droid Sans": "Droid+Sans:400,700",
   "Josefin Sans": "Josefin+Sans:400,700",
   "Josefin Slab": "Josefin+Slab:400,700",
   "Lato": "Lato:400,700",
   "Merriweather": "Merriweather:400,900italic,700italic,900,400italic,300italic,300,700",
   "Montserrat": "Montserrat:400,700",
   "Old Standard TT": "Old+Standard+TT:400,700",
   "Open Sans": "Open+Sans:400,700",
   "Oswald": "Oswald:400,300,700",
   "Prociono": "Prociono",
   "PT Sans": "PT+Sans:400,700",
   "PT Serif": "PT+Serif:400,700",
   "Raleway": "Raleway:400,300,700,500",
   "Roboto": "Roboto:500,900italic,900,400italic,100,700italic,300,700,500italic,100italic,300italic,400",
   "Roboto Sans": "Roboto+Condensed:300italic,400italic,700italic,400,700,300",
   "Roboto Slab": "Roboto+Slab:400,300,100,700",
   "Signika": "Signika:400,700,600,300",
   "Ubuntu": "Ubuntu:400,700",
   "Varela": "Varela",
   "Varela Round": "Varela+Round",
   "Vollkorn": "Vollkorn:400,700",
   "Fira Sans": "Fira+Sans:400,300,500,700:latin",
   "Source Sans Pro": "Source+Sans+Pro:400,200,200italic,300,300italic,400italic,600,600italic,700,700italic:latin",
   "Vidaloka": "Vidaloka::latin"
  }
});

